import React, {Component} from 'react';
import * as actionCreator from "../../../../store/Action";
import {connect} from "react-redux";
import {MDBDataTable} from "mdbreact";
import {Card, CardBody, CardHeader, Col, Row} from "reactstrap";
import {Button as SementicBtn, Dropdown, Input} from "semantic-ui-react";
import Update from "./Update";
import Cookies from "js-cookie";
import axiosTags from "../../../../axios/axios_tag";
import * as common from "../../../../const/Common/CommonFunc";
import {Icon, Spin} from "antd";
import apiConfig from "../../../../axios/axios_api_services";
import {ViewAllPublicUsers} from "../../../../const/table/TableHeaders";
import Pagination from "../../../../components/Pagination/Pagination";
import LabelDropdown from "../../../../components/Dropdown/LabelDropdown/LabelDropdown";
import * as DropDownConst from "../../../../store/Reducer/DropDownConst";
import Delete from "./Delete";

class App extends Component {

  state = {
    isUpdate: false,
    corporate_data: null,
    isSpin: false,
    data:[],
    page: 0,
    size: 10,
    totalNoOfPages: 0,
    searchValue: '',
    firstRow: 0,
    lastRow: 0,
    totalRows: 0, deleteObj: null
  };

  handleUpdate = () => {
    // this.getAllUsers();
    this.setState({
      isUpdate: !this.state.isUpdate
    })
  };

  updateCorporate = (obj) => {
    this.setState({
      corporate_data: obj,
      isUpdate: true
    });
  };

  changeSpinner = (condition) => {
    this.setState({
      isSpin: condition
    })
  };

  getAllUsers = () => {
    if(this.state.searchValue.trim() !== "") return this.searchPublicUserWithPagination(0);

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    this.changeSpinner(true);
    axiosTags.get(apiConfig.SEARCH_PUBLIC_USERS_WITH_PAGINATION({index:this.state.page, size:this.state.size, searchValue:""}), {headers: headers})
      .then(response => {
        if (response.data.success) {
          this.setState({
            data: response.data.body.content,
            page: response.data.body.number,
            totalNoOfPages: response.data.body.totalPages,
            firstRow: response.data.body.totalElements !== 0 ? response.data.body.pageable.offset + 1 : response.data.body.pageable.offset,
            lastRow: (response.data.body.pageable.offset + 1) + (response.data.body.numberOfElements - 1),
            totalRows: response.data.body.totalElements
          })
        } else {
          this.setState({
            data: []
          })
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllUsers()
        }
      })
      .finally(fin => {
        this.changeSpinner(false);
      });
  };

  componentDidMount() {
    this.getAllUsers();
  }

  handlePagination = async (page) => {
    await this.setState({page: (page-1)})
    this.getAllUsers();
  }

  onHandleChange = name => e => {
    let value = e.target.value;
    switch (name) {
      case "searchUser" :
        this.setState({searchValue : value});
        break;
      case "changeEntries" :
        this.setState({
          size : e.target.value,
          page : 0
        },() => {
          this.getAllUsers();
        });
        break;
      default:
        break;
    }
  }

  searchPublicUserWithPagination = (status) => {
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    this.changeSpinner(true);
    axiosTags.get(apiConfig.SEARCH_PUBLIC_USERS_WITH_PAGINATION({index:status === 1 ? 0 : this.state.page, size:this.state.size, searchValue:this.state.searchValue.trim()}), {headers: headers})
      .then(response => {
        if (response.data.success) {
          this.setState({
            data: response.data.body.content,
            page: response.data.body.number,
            totalNoOfPages: response.data.body.totalPages,
            firstRow: response.data.body.totalElements !== 0 ? response.data.body.pageable.offset + 1 : response.data.body.pageable.offset,
            lastRow: (response.data.body.pageable.offset + 1) + (response.data.body.numberOfElements - 1),
            totalRows: response.data.body.totalElements
          })
        } else {
          this.setState({
            data: []
          })
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllUsers()
        }
      })
      .finally(fin => {
        this.changeSpinner(false);
      });
  }

  render() {
    let {page,totalNoOfPages,size,firstRow,lastRow,totalRows,deleteObj} = this.state;
    let rows = [];
    let all_corporates = this.state.data;
    if (all_corporates.length !== 0) {
      all_corporates.map((cor, index) => {
        const obj = {
          fName: cor.firstName,
          lName: cor.lastName,
          mobile: cor.mobile,
          idType: cor.identificationType,
          idValue: cor.identificationValue,
          email: cor.email,
          more: <div>
            <button className={'cmn-edit-btn mr-1'} onClick={() => this.updateCorporate(cor)}>Edit</button>
            <button className={'cmn-delete-btn'} onClick={() => this.setState({deleteObj: cor})}>Delete</button>
            {/*<SementicBtn circular icon='edit' className={"more-update"}*/}
            {/*             onClick={() => this.updateCorporate(cor)}/>*/}
          </div>
        };
        rows.push(obj)
      })
    }

    let columns = ViewAllPublicUsers;
    let table_data = {columns, rows};

    return (
      <Row>
        {this.state.isUpdate ? <Update closeModal={this.handleUpdate} data={this.state.corporate_data} refreshData={this.getAllUsers}/> : null}
        {deleteObj ? <Delete isPublic={true} closeModalHandler={()=>this.setState({deleteObj:null})} data={deleteObj} refreshData={this.getAllUsers}/> : null}
        <Col lg="12">
          <Card>
            <CardHeader>
              Public Users Details
            </CardHeader>
            <CardBody>
              <Spin spinning={this.state.isSpin} delay={10}
                    indicator={<Icon type="loading" style={{fontSize: 24}} spin/>}>
                <Row className={"align-items-center justify-content-between mb-2"}>
                  <Col lg={"2"} md={"3"} sm={"4"} xs={"4"}>
                    <Col className={"d-flex flex-column pl-0"}>
                      <label className={"font-smaller"}>Show entries</label>
                      <select style={{width: "40%"}} value={size} onChange={this.onHandleChange("changeEntries")}>
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                      </select>
                    </Col>
                  </Col>
                  <Col lg={"4"} md={"5"} sm={"7"} xs={"7"} className={"d-flex"}>
                  <Col className={"w-75"}>
                    <Input
                     className={"w-100"}
                     icon='search'
                     iconPosition='left'
                     placeholder='Search Here'
                     value={this.state.searchValue}
                     onChange={this.onHandleChange("searchUser")}
                    />
                  </Col>
                  <Col lg={"1.5"} md={"1.5"} sm={"1.5"} xs={"1.5"}>
                    <SementicBtn className="ui inverted primary button" onClick={()=>this.searchPublicUserWithPagination(1)}>Search</SementicBtn>
                  </Col>
                  </Col>
                </Row>
              <MDBDataTable
                className={"mb-0"}
                id={"all-corporate-table"}
                searching={false}
                searchLabel={"Search here"}
                responsiveSm
                responsiveMd
                responsiveLg
                responsiveXl
                // info={false}
                paging={false}
                // striped={true}
                // entriesLabel={false}
                // entries={false}
                sortable={false}
                bordered
                hover
                data={table_data}/>
                <label className={"font-smaller mt-2"}>Showing {firstRow} to {lastRow} of {totalRows} entries</label>
                <Row className={"align-items-center justify-content-center"}>
                <Col lg={4} md={6} sm={12} xs={12}>
                  {/*<div className={"full-width align-center"}>*/}
                    { totalNoOfPages > 1 ? <Pagination activePage={(page + 1)} totalNoOfPages={totalNoOfPages}
                                 handlePagination={this.handlePagination}/> : null}
                  {/*</div>*/}
                </Col>
                </Row>
              </Spin>
            </CardBody>
          </Card>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (state) => ({
  view_all_corporates: state.COPUserReducer.view_all_corporates_users, //not use
  corporate_headers: state.COPUserReducer.corporate_user_headers,
  // usr obj
  usr_obj: state.userReducer.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    getAllCorporateUsers: (data) => dispatch(actionCreator.getAllCorporateUsers(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
